export default __webpack_public_path__ + "static/msteamsnotifications-dcba7d8f14d7524ef1f66dcb6200d465.svg";